<div class="support-tab-Container flex flex-row">

  <div class="left-side-container">
    <div class="sub-tab" [ngClass]="{'active' : selectedButton === TabNames.testCompanies}">
      <button mat-button (click)="onClickButton(TabNames.testCompanies)"> {{TabNames.testCompanies}} </button>
    </div>
    <div class="sub-tab" [ngClass]="{'active' : selectedButton === TabNames.emailNotificationConfiguration}">
      <button mat-button (click)="onClickButton(TabNames.emailNotificationConfiguration)"> {{TabNames.emailNotificationConfiguration}} </button>
    </div>

  </div>
  <div class="right-side-container">
    <div *ngIf="selectedButton === TabNames.testCompanies">
      <app-exclude-test-companies [items]="testCompanies"></app-exclude-test-companies>
    </div>
    <div *ngIf="selectedButton === TabNames.emailNotificationConfiguration">
      <app-support-email-configuration [emailConfiguration] = emailConfiguration></app-support-email-configuration>
    </div>
  </div>



</div>
